import(/* webpackMode: "eager", webpackExports: ["AppHomePageSkeleton"] */ "/opt/cal.com/apps/web/app/(use-page-wrapper)/apps/(homepage)/skeleton.tsx");
